module.exports = __webpack_public_path__ + "media/uglyBeauty_cover.aa3dc47a.mp3";